import { render, staticRenderFns } from "./TwoColumnsBlock.vue?vue&type=template&id=1b8f988a&"
import script from "./TwoColumnsBlock.vue?vue&type=script&lang=js&"
export * from "./TwoColumnsBlock.vue?vue&type=script&lang=js&"
import style0 from "./TwoColumnsBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports